<template>
    <div>
        <div style="display: flex; align-items: center; justify-content: flex-end; margin-bottom: 40px">
            <div style="float: right">
                <el-button type="primary" size="mini" icon="el-icon-plus" @click="add" v-if="perData.allow_add == 1">{{ $t('common.add') }}</el-button>
                <el-button
                    type="warning"
                    size="mini"
                    icon="el-icon-edit"
                    :disabled="isAdd || !isedit || nullBtn"
                    @click="handelEdit"
                    v-if="perData.allow_edit == 1"
                    >{{ $t('common.edit') }}</el-button
                >
                <el-button
                    type="danger"
                    size="mini"
                    icon="el-icon-delete"
                    :disabled="isAdd || !isedit || nullBtn"
                    @click="removeEvent"
                    v-if="perData.allow_dele == 1"
                    >{{ $t('common.delete') }}</el-button
                >
                <el-button
                    type="success"
                    size="mini"
                    icon="el-icon-document-checked"
                    :disabled="nullBtn || isedit"
                    @click="saveIt"
                    v-preventReClick
                    v-if="perData.allow_edit == 1"
                    >{{ $t('common.save') }}</el-button
                >
                <el-button
                    type="info"
                    size="mini"
                    icon="el-icon-refresh-left"
                    :disabled="nullBtn || isedit"
                    v-if="perData.allow_edit == 1"
                    @click="refreshData()"
                    >撤回</el-button
                >
                <!-- <el-button type="primary" size="mini" icon="el-icon-printer" :disabled="isAdd||!isedit||nullBtn">{{ $t('common.print') }}</el-button> -->
            </div>
        </div>
        <!-- <div style="margin-bottom:10px;text-align:right;margin-top:50px;">
            <el-button type="primary" size="mini" icon="el-icon-plus" :disabled="isedit" @click="insertEvent(-1)">{{ $t('common.add') }}</el-button>
            <el-button type="danger" size="mini" icon="el-icon-delete" :disabled="isedit" @click="removeEvent()">{{ $t('common.delete') }}</el-button>
        </div> -->
        <vxe-table
            border
            stripe
            resizable
            keep-source
            align="center"
            ref="xTable1"
            height="600"
            show-overflow
            highlight-hover-row
            :loading="loading"
            :keyboard-config="{ isArrow: true, isEnter: true, isTab: true, isEdit: true }"
            :row-class-name="rowChange"
            :edit-rules="validRules"
            :data="tableData"
            :mouse-config="{ selected: true }"
            :edit-config="{ trigger: 'click', mode: 'cell', icon: 'fa fa', activeMethod: activeRowMethod }"
        >
            <vxe-table-column type="checkbox" width="50"></vxe-table-column>
            <vxe-table-column type="seq" field="seq" width="50" title="序号"></vxe-table-column>
            <!-- <vxe-table-column field="outcounter_no" title="发出柜台" :edit-render="{name: '$select' , options: allArr.counter, props: { clearable: true ,placeholder:'请输入',disabled: isedit},optionProps: {value: 'kind_no', label: 'kind_name'}}"></vxe-table-column> -->
            <vxe-table-column title="发出仓库" field="outcounter_no" :edit-render="{}">
                <template v-slot:edit="{ row }">
                    <el-select v-model="row.outcounter_no" filterable ref="nofocus" default-first-option placeholder="请选择">
                        <el-option
                            v-for="item in allArr.counter"
                            :key="item.kind_no"
                            :label="item.kind_name"
                            :value="item.kind_no"
                        ></el-option>
                    </el-select>
                </template>
                <template v-slot="{ row }">{{ getSelectLabel(row.outcounter_no, allArr.counter) }}</template>
            </vxe-table-column>
            <!-- <vxe-table-column field="intcounter_no" title="接收柜台" :edit-render="{name: '$select' , options: allArr.counter, props: { clearable: true ,placeholder:'请输入',disabled: isedit},optionProps: {value: 'kind_no', label: 'kind_name'}}"></vxe-table-column> -->
            <vxe-table-column title="接收仓库" field="intcounter_no" :edit-render="{}">
                <template v-slot:edit="{ row }">
                    <el-select v-model="row.intcounter_no" filterable default-first-option placeholder="请选择">
                        <el-option
                            v-for="item in allArr.counter"
                            :key="item.kind_no"
                            :label="item.kind_name"
                            :value="item.kind_no"
                        ></el-option>
                    </el-select>
                </template>
                <template v-slot="{ row }">{{ getSelectLabel(row.intcounter_no, allArr.counter) }}</template>
            </vxe-table-column>
            <vxe-table-column title="使用模块" field="code" :edit-render="{}">
                <template v-slot:edit="{ row }">
                    <el-select v-model="row.code" filterable default-first-option placeholder="请选择">
                        <el-option v-for="item in allArr.code" :key="item.code" :label="item.chinese" :value="item.code"></el-option>
                    </el-select>
                </template>
                <template v-slot="{ row }">{{ getSelectLabel2(row.code, allArr.code) }}</template>
            </vxe-table-column>
            <!-- <vxe-table-column field="code" title="使用模块" :edit-render="{name: '$select' , options: allArr.code, props: { clearable: true ,placeholder:'请输入',disabled: isedit},optionProps: {value: 'code', label: 'chinese'},events:{keyup:enterFilterEvent}}"></vxe-table-column> -->
            <!-- <vxe-table-column v-if="false" title="#" field="code"  width="50"></vxe-table-column>
          <vxe-table-column title="使用模块" field="chinese" :edit-render="{}" >
              <template  v-slot:edit="{ row }">
                <vxe-pulldown style="width:100%" ref="xDown1">
                  <template>
                    <vxe-input v-model="row.chinese" placeholder="请选择" @focus="focusEvent1" @keyup="keyupEvent1(row)"></vxe-input>
                  </template>
                  <template v-slot:dropdown>
                    <div class="my-dropdown1">
                      <div class="list-item1" v-for="item in pull_code" :key="item.code" @click="selectEvent1(item,row)">
                        <span>{{item.chinese }}</span>
                      </div>
                    </div>
                  </template>
                </vxe-pulldown>
              </template>
            </vxe-table-column> -->
        </vxe-table>
    </div>
</template>

<script>
import { apiCurrentPermisson, apisetListCounter, apimodifyCounter, apidelCounter, apiSCounter } from '@/request/api';
// import $ from jquery
export default {
    data() {
        return {
            tableData: [],
            allArr: '',
            isedit: true,
            isAdd: false,
            loading: false,
            perData: '',
            validRules: {
                outcounter_no: [{ required: true, message: '发出仓库必须填写' }],
                intcounter_no: [{ required: true, message: '接收仓库必须填写' }],
                code: [{ required: true, message: '使用模块必须填写' }]
            },
            nullBtn: false,
            pull_code: []
        };
    },
    created() {
        this.geData();
        this.getPermission();
        this.getSelectData();
    },
    methods: {
        // 获取页面信息-----------------------------------------
        geData() {
            const loading = this.$loading({
                lock: true,
                text: '拼命加载中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)'
            });
            this.isAdd = false;
            apisetListCounter({}).then((res) => {
                if (res.code == 2000) {
                    this.tableData = res.data;
                } else {
                    if (res.data.info == '无数据请先添加' || res.data.info == '没有这条数据') {
                        this.tableData = [];
                        this.nullBtn = true;
                    }
                    this.$message.error(res.data.info);
                }
            });
            loading.close();
        },
        //下拉列表-----------------------------------------------------
        getSelectData() {
            apiSCounter({}).then((res) => {
                if (res.code == 2000) {
                    this.allArr = res.data;
                    this.pull_code = res.data.code;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        // 撤回操作--------------------------------------
        refreshData(no) {
            this.isedit = true;
            this.isAdd = false;
            this.geData();
        },
        //首次进入页面 页面不可编辑状态--------------------------------
        handelEdit() {
            if (this.isedit == true) {
                this.isedit = false;
            }
        },
        // 保存修改------------------------------------------
        saveIt() {
            var table1 = this.$refs.xTable1.getTableData().fullData;

            // if(this.isAdd==true){
            //   apimodifyCounter(table1).then(res => {
            //     if(res.code==2000){
            //         this.$message.success('添加成功');//添加商品
            //         this.tableData = res.data;
            //         this.isAdd=false;
            //         this.isedit=true;
            //     }else{
            //         this.$message.error(res.data.info);
            //     }
            //   })
            // }else{
            apimodifyCounter(table1).then((res) => {
                if (res.code == 2000) {
                    this.$message.success('修改成功'); //修改商品
                    this.tableData = res.data;
                    this.isedit = true;
                    this.isAdd = false;
                } else {
                    this.$message.error(res.data.info);
                }
            });
            // }
        },
        //添加产品-----------------------------------
        add() {
            // if(this.isAdd==false){
            this.isedit = false;
            this.isAdd = true;
            // this.tableData=[{}];
            this.insertEvent(-1);
            this.nullBtn = false;
            // }else{
            //   this.$message.error('请先保存再添加下一个');
            // }
        },
        //删除产品-----------------------------------------
        delGold() {
            this.$confirm('确定要清空吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    // apidelCounter({}).then(res => {
                    //     if(res.code==2000){
                    //         this.$message({message: "清空成功",type: 'success',});
                    //         this.tableData = [];
                    //         if(res.data==null){
                    //           this.nullBtn=true;
                    //         }
                    //     }else{
                    //         this.$message.error(res.data.info);
                    //     }
                    // })
                    this.removeEvent();
                    this.saveIt();
                })
                .catch(() => {});
        },
        // 获取seq---------------------------
        rowChange(row) {
            row.row.seq = row.seq;
        },
        //插入新数据--------------------------------------------
        async insertEvent(row) {
            let record = {
                outcounter_no: ''
            };
            let { row: newRow } = await this.$refs.xTable1.insertAt(record, row);
            await this.$refs.xTable1.setActiveCell(newRow, 'outcounter_no');
            this.$refs.nofocus.focus();
        },

        //删除--------------------------------------------
        removeEvent() {
            let length = this.$refs.xTable1.getCheckboxRecords();
            if (length.length == 0) {
                this.$message.error('请选择你要删除的');
            } else {
                this.$XModal.confirm('您确定要删除该数据?').then((type) => {
                    if (type === 'confirm') {
                        this.$refs.xTable1.removeCheckboxRow();
                        this.saveIt();
                    }
                });
            }
        },
        //回车事件-----------------------------------------
        enterFilterEvent({ $panel, row }, event) {
            if (event.keyCode === 13) {
                this.insertEvent(-1);
            } else if (event.keyCode === 46) {
                this.$refs.xTable1.remove(row);
            }
        },
        // 不可编辑-------------------------------------
        activeRowMethod() {
            if (this.isedit == false) {
                return true;
            } else {
                this.$message.error('该状态下不可编辑');
                return false;
            }
        },
        //获得页面按钮的权限（添加，修改，删除）
        getPermission() {
            apiCurrentPermisson({
                id: '44'
            }).then((res) => {
                if (res.code == 2000) {
                    //
                    this.perData = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        // vxe-table自定义下拉容器
        focusEvent1() {
            this.$refs.xDown1.showPanel();
        },
        keyupEvent1(row) {
            var val = row.chinese;
            if (val) {
                var len = this.allArr.code;
                var arr = [];
                for (var i = 0; i < len.length; i++) {
                    // len[i].code.toLowerCase().indexOf(val.toLowerCase())>=0||
                    if (len[i].chinese.indexOf(val) >= 0) {
                        arr.push(len[i]);
                    }
                }
                this.pull_code = arr;
            } else {
                this.pull_code = this.allArr.code;
            }
        },
        selectEvent1(item, row) {
            //
            row.chinese = item.chinese;
            row.code = item.code;
            this.$refs.xDown1.hidePanel().then(() => {
                this.pull_code = this.allArr.code;
            });
        },
        getSelectLabel(value, list) {
            if (list) {
                let item = list.find((item) => item.kind_no === value);
                return item ? item.kind_name : null;
            }
        },
        getSelectLabel2(value, list) {
            if (list) {
                let item = list.find((item) => item.code === value);
                return item ? item.chinese : null;
            }
        }
    }
};
</script>

<style scoped></style>
<style>
.vxe-table thead {
    background-color: #ecf5ff;
}
.vxe-table {
    background: #fff;
}
.vxe-table .vxe-body--row.row--hover,
.vxe-table .vxe-body--row.row--hover.row--stripe {
    background-color: #ecf5ff;
}
.el-select {
    width: 100%;
}
.my-dropdown1 {
    height: auto;
    max-height: 200px;
    width: auto;
    padding: 2px 5px;
    overflow: auto;
    border-radius: 4px;
    background-color: #fff;
    border: 1px solid #dcdfe6;
}
.list-item1:hover {
    background-color: #f5f7fa;
}
</style>
